import * as React from "react";
import { SVGProps } from "react";
export const CalendarPlusFillIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M14.25 18V15.75H12V14.25H14.25V12H15.75V14.25H18V15.75H15.75V18H14.25ZM4.5 16C4.09733 16.014 3.74667 15.868 3.448 15.562C3.14933 15.2567 3 14.9027 3 14.5V5.5C3 5.08333 3.14933 4.72933 3.448 4.438C3.74667 4.146 4.09733 4 4.5 4H5.5V2H7V4H11V2H12.5V4H13.5C13.9027 4 14.2567 4.146 14.562 4.438C14.868 4.72933 15.014 5.08333 15 5.5V10C14.75 10 14.5 10.0207 14.25 10.062C14 10.104 13.75 10.1667 13.5 10.25V9H4.5V14.5H10.042C10.014 14.736 10.0033 14.979 10.01 15.229C10.0173 15.479 10.0487 15.736 10.104 16H4.5Z"
            fill="currentColor"
        />
    </svg>
);
CalendarPlusFillIcon.displayName = "CalendarPlusFillIcon";
